<template>
  <div class="max-w-xs space-y-1 text-sm">
    <div class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
      <p class="font-semibold">{{ content.title }}</p>
      <LicencePlate v-if="content.licencePlate" class="mb-0">{{
        content.licencePlate
      }}</LicencePlate>
    </div>
    <p v-for="(row, i) in content.rows" :key="i" class="flex items-start gap-1.5 text-obsidian-700">
      <component
        :is="icons[row.icon]"
        v-if="row.icon"
        class="mt-0.5 size-4 shrink-0"
        :class="iconClass[row.icon]"
      />
      <span>{{ row.text }}</span>
    </p>
    <div
      v-if="content.allocationStatus || content.badges?.length"
      class="flex flex-wrap items-center gap-1 pt-0.5"
    >
      <AllocationStatusBadge v-if="content.allocationStatus" :status="content.allocationStatus" />
      <Badge v-for="(badge, i) in content.badges" :key="i" :variant="badge.variant">
        {{ badge.text }}
      </Badge>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ArrowLeftToLineIcon,
  ArrowRightFromLineIcon,
  HashIcon,
  MapPinIcon,
  UserIcon,
  WrenchIcon,
} from 'lucide-vue-next';
import LicencePlate from '@/components/LicencePlate.vue';
import AllocationStatusBadge from '@/components/badges/AllocationStatusBadge.vue';
import Badge from '@/components/Badge.vue';
import type { GanttHoverContent, GanttHoverIcon } from './interfaces';

defineProps<{
  content: GanttHoverContent;
}>();

const icons: Record<GanttHoverIcon, typeof UserIcon> = {
  start: ArrowRightFromLineIcon,
  end: ArrowLeftToLineIcon,
  user: UserIcon,
  pin: MapPinIcon,
  hash: HashIcon,
  wrench: WrenchIcon,
};

const iconClass: Record<GanttHoverIcon, string> = {
  start: 'text-hazel-500',
  end: 'text-hazel-500',
  user: 'text-obsidian-500',
  pin: 'text-obsidian-400',
  hash: 'text-obsidian-400',
  wrench: 'text-obsidian-400',
};
</script>
